import React from "react";

function CategoryDetails() {
  return <div>CategoryDetails</div>;
}

export default CategoryDetails;
